var googleFonts = [];

















settings = {}
settings.logo                   = true;
settings.products               = new Array();
settings.currency               = '';
settings.currencyFormat         = "";
settings.shippingCalculator     = 'false';
settings.productImageBorders    = true;
settings.slideshowPagination    = true;
settings.autoplaySlideshow      = false;
settings.autoplayDelay          = '';
settings.fullsizeProductViewer  = true;
settings.moneyFormat            = "";
settings.moneyFormatCurrency    = "";
settings.shippingCalculator     = false;
settings.userLoggedIn           = false;
settings.userAddress            = '';



shopCurrency = settings.currency;




jQuery(document).ready(function($) {
  $('.fake-select').fakeSelect();
});